<template>
  <fullscreen-modal
    id="updatePassword"
    ref="modal"
    :show-close-btn="false"
  >
    <div>
      <div class="fullscreen-modal__content">
        <page>
          <page-title v-t="'c.updatePasswordOverlay.title'"/>

          <form-wrap @submit="onSubmit">
            <form-field-set :should-show-border="false">
              <text-input
                v-model="$v.currentPassword.$model"
                :error="currentPasswordError"
                :label="$t('c.updatePasswordOverlay.form.labels.currentPassword')"
                name="currentPassword"
                type="password"
              />

              <text-input
                v-model="$v.password.$model"
                :error="passwordError"
                :label="$t('c.updatePasswordOverlay.form.labels.password')"
                name="password"
                type="password"
              />

              <text-input
                v-model="$v.passwordConfirmation.$model"
                :error="passwordConfirmationError"
                :label="$t('c.updatePasswordOverlay.form.labels.passwordConfirmation')"
                name="passwordConfirmation"
                type="password"
              >
                <security-indicator
                  slot="addon"
                  :percent="percentNumber"
                  class="password-indicator"
                />
              </text-input>
            </form-field-set>
          </form-wrap>

        </page>
      </div>
      <div class="fullscreen-modal__footer">
        <div class="container">
          <div class="row">
            <div class="col-xs-6 col-lg-4 push-lg-2">
              <button-input
                v-t="'c.updatePasswordOverlay.btnSubmit'"
                :is-disabled="!isValid"
                @click="onSubmit"
              />
            </div>

            <div class="col-xs-6 col-lg-4 push-lg-2 text-right">
              <button-input
                v-t="'c.updatePasswordOverlay.btnLogout'"
                color="grey"
                @click="signOut"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </fullscreen-modal>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import PageMixin from '@/mixins/pages/Page'
import FormMixin from '@/mixins/forms/Form'
import FullscreenModal from '@/components/app/FullscreenModal'
import NotificationsMixin from '@/mixins/notifications/notifications'
import SecurityIndicator from '@/components/forms/SecurityIndicator'
import zxcvbn from 'zxcvbn'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [
    PageMixin,
    FormMixin,
    validationMixin,
    NotificationsMixin
  ],
  components: {
    SecurityIndicator,
    FullscreenModal
  },
  validations: {
    currentPassword: {
      required
    },
    password: {
      required
    },
    passwordConfirmation: {
      required
    }
  },
  computed: {
    ...mapState({
      currentUser: state => state.currentUser.currentUser
    }),
    ...mapGetters({
      currentUserId: 'currentUserId',
    }),
    currentPassword: {
      get () { return this.$store.state.passwordForm.form.currentPassword },
      set (value) { this.$store.dispatch('passwordForm/setCurrentPassword', value) }
    },
    password: {
      get () { return this.$store.state.passwordForm.form.password },
      set (value) { this.$store.dispatch('passwordForm/setPassword', value) }
    },
    passwordConfirmation: {
      get () { return this.$store.state.passwordForm.form.passwordConfirmation },
      set (value) { this.$store.dispatch('passwordForm/setPasswordConfirmation', value) }
    },
    currentPasswordError () {
      return this.$v.currentPassword.$error
        ? 'Dies ist ein Pflichtfeld'
        : ''
    },
    passwordError () {
      return this.$v.password.$error
        ? 'Dies ist ein Pflichtfeld'
        : ''
    },
    passwordConfirmationError () {
      return this.$v.passwordConfirmation.$error
        ? 'Dies ist ein Pflichtfeld'
        : ''
    },
    isValid () {
      return this.score == 4 && this.password == this.passwordConfirmation
    },
    score () {
      return zxcvbn(this.password).score
    },
    percentNumber () {
      return this.score > 0
        ? this.score * 25
        : 0
    }
  },
  methods: {
    ...mapActions({
      signOut: 'signOut',
      show: 'passwordForm/show',
      update: 'passwordForm/update',
      reset: 'passwordForm/reset',
      fetchCurrentUser: 'fetchCurrentUser',
    }),
    onSubmit () {
      this.$v.$touch()

      if(this.$v.$invalid) {
        this.errorNotification('Bitte überprüfen Sie ihre Eingaben.')
      } else {
        return this.update({ userId: this.currentUserId })
          .then(() => {
            this.fetchCurrentUser()
              .then(() => {
                this.$refs.modal.closeModal()
                this.$router.push({ name: 'Home' })
              })

          })
          // .then(this.resetUpdateErrors)
          .catch(this.somethingWentWrongNotification)
      }
    }
  },
  beforeDestroy () {
    this.reset()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/profile/UpdatePasswordOverlay.vue